import React from 'react'
import { isEmpty } from 'lodash'

import { Table } from '@/components/tables/Table/Table'

// Rows follow the scorecard criteria convention: a group row points at its
// children via `nestedField`, and any cell may be `{ value, as, cellProps }`
const flattenSummaryRows = (rows) => {
  return rows.flatMap((row) => {
    if (row.nestedField) {
      return [{ isGroup: true, row }, ...flattenSummaryRows(row[row.nestedField])]
    }
    return [{ isGroup: false, row }]
  })
}

const rowKey = (row) => row.key || row.playbook_ref_id || row?.name?.value || row?.name

export const ScorecardCriteriaSummaryTable = ({ columns, rows, header }) => {
  if (isEmpty(rows)) {
    return null
  }

  return (
    <section>
      {header && <h4 className="mt mb">{header}</h4>}
      <Table>
        <tbody>
          {flattenSummaryRows(rows).map(({ isGroup, row }) =>
            isGroup ? (
              <tr key={rowKey(row)}>
                <td colSpan={columns.length}>
                  <strong>{row.name?.value || row.name}</strong>
                </td>
              </tr>
            ) : (
              <tr key={rowKey(row)} data-testid="basic-table-row">
                {columns.map((column) => {
                  const cell = row[column.accessor]

                  return (
                    <td key={column.accessor} className={cell?.cellProps?.className}>
                      {cell?.as || cell}
                    </td>
                  )
                })}
              </tr>
            )
          )}
        </tbody>
      </Table>
    </section>
  )
}
